module.exports = __webpack_public_path__ + "img/thumb_10.59cfc95c.jpg";